
function Cockpit1() {
    /// <summary>
    /// This object provides client-side functions for the Widget.Cockpit.Cockpit1 visual. <br/>
    /// 
    /// <br/>
    /// Author: ARF<br />
    /// Date: 9.11.2018<br />
    /// Copyright ©: EUDT GmbH 2018 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 5.12.2018                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>
    // the following attributes got set in Charts.Cockpit.Cockpit1.vb
    this.day = "";
    this.bsaid = -1;
   
    this.dates = null;
    this.maxBrowserHeight = 1440;
    this.minSingleHeight = 220;
}

Cockpit1.prototype = new vcTemplate();

Cockpit1.prototype.init = function () {
    /// <summary>
    /// This function inits the menu click handler. 
    /// </summary>
    var me = this;
    var id;
    var iSingleHeight = 240;
    try {
        if (me.error) { return false; }
        me.showInfo("", "", false);
        
        //if (me.mobile === false) {
        // //   me.visual.find("#divContentSub1").width(parseInt(me.visual.find("#divContentSub1").width(), 10)-2);
        //}
       
        me.visual.find(".date-menu .button-toggle[data-interval='" + me.interval + "']").addClass("button-toggle-active");

        me.visual.find('.price').off("click").on("click",
            function () {
               
                if ($(this).hasClass("button-toggle-active")) {
                    me.usePrices = false;
                    $(this).removeClass("button-toggle-active");
                } else {
                    $(this).addClass("button-toggle-active");
                    me.usePrices = true;
                }
               
                _VCMQ.produce(me.visual, me.vcgid, 'CHANGE_DATE', { 'dates': me.dates, 'interval': me.interval, 'usePrices': me.usePrices, 'vcgid': -1 });
            });


        //_VCMQ.produce(me.visual, me.vcgid, 'CHANGE_DATE', { 'dates': me.dates, 'interval': me.interval, 'vcgid': -1 });

        me.initDates("");
       

        me.initIntervals(me.interval,"");

        if (me.visual.find(".div-visual").length === 3) {
            var browserHeight = parseInt(_iBrowserHeight) -
                parseInt($("#header").height() + me.visual.find(".date-menu").outerHeight() + 30);
            iSingleHeight = parseInt(browserHeight / 3) - 10;
        }

      
        if (iSingleHeight < me.minSingleHeight) { iSingleHeight = me.minSingleHeight; }
        me.visual.find(".div-visual").each(function () {
            id = parseInt($(this).data("id"), 10);
            me.vcVisual.addVisualBaseByName("div_", "VISUAL_COCKPIT_SINGLESIGNAL",me.vcgid + "_" + id, me.day,iSingleHeight, parseInt($(this).width(), 10),"", JSON.stringify({ 'signalid': id, 'ShowDetails': true, 'UsePrices':me.usePrices,'Interval':me.interval }),me.deviceType);
        });




       
        me.doEvent(null);
        return true;
       
    } catch (ex) { me.writeError('init', ex); return false }

}

Cockpit1.prototype.initDates = function (defaultDate) {
    /// <summary>
    /// This function inits the menu click handler - optionally with a default date. 
    /// </summary>
    var me = this;
    var settings;
    try {
        if (me.error) { return false; }
        //console.info(me);
        //alert(me.userLangidForCulture);
        settings = {
            mode: 'Single', align: 'center', interval: me.interval, langID: me.userLangidForCulture,
            callback: function (obj) {
                me.dates = obj;
                _VCMQ.produce(me.visual, me.vcgid, 'CHANGE_DATE', { 'dates': me.dates, 'interval': me.interval, 'usePrices': me.usePrices, 'vcgid': -1 });
              
            }
        }
        if (defaultDate.length > 0) {
            settings.defaultDate = defaultDate;
        }

        me.visual.find(' .date').vcDate(settings);

        return true;
    } catch (ex) { me.writeError('initDates', ex); return false }

}

Cockpit1.prototype.initIntervals = function () {
    /// <summary>
    /// This function inits the interval menu click handler. 
    /// </summary>
    var me = this;

    try {
        if (me.error) { return false; }

        me.visual.find('.date-menu .button-toggle').off("click").on("click", function() {

            me.changeInterval($(this));
            //me.visual.find('.date-menu .button-toggle').removeClass("button-toggle-active");
            //$(this).addClass("button-toggle-active");
            //me.interval = parseInt($(this).data("interval"), 10);
            ////after reseting the interval we have to destroy the vcDate and re-init it.
            //me.visual.find('.date').vcDate("destroy");
            //me.initDates("");

        });

        return true;
    } catch (ex) { me.writeError('initIntervls', ex); return false }

}

Cockpit1.prototype.changeInterval = function (obj) {
    /// <summary>
    /// This function inits the interval menu click handler. 
    /// </summary>
    var me = this;

    try {
        if (me.error) { return false; }

        me.visual.find('.date-menu .button-toggle').removeClass("button-toggle-active");
        obj.addClass("button-toggle-active");
        me.interval = parseInt(obj.data("interval"), 10);
        //after reseting the interval we have to destroy the vcDate and re-init it.
        me.visual.find('.date').vcDate("destroy");
        me.initDates("");

        return true;
    } catch (ex) { me.writeError('changeInterval', ex); return false }

}


Cockpit1.prototype.toggleDetails = function (msg) {
    /// <summary>
    /// This function reloads the detail visual in the bottom.
    /// </summary>
    var me = this;
    var visual;
    var h;
    var browserHeight = 0;
    try {
      
        me.bsaid = msg.obj.data("id");
        me.day = msg.day;
        //toggle the left main buttons
        visual = me.visual.find(".div-visual[data-id='" + me.bsaid + "']");
        me.visual.find(".details.button-toggle").removeClass("button-toggle-active");

        if (me.visual.find("#div-details").hasClass("hidden")) {
            me.visual.find(".div-visual").fadeOut(0);
           
            msg.obj.addClass("button-toggle-active");

            browserHeight = parseInt($(window).height(), 10)-10;        
            if (browserHeight > me.maxBrowserHeight) { browserHeight = me.maxBrowserHeight; }

            var selectionHeight = $(".cockpit-selection #div-menu").height();
            if (selectionHeight == null) {
                selectionHeight = 0;
            } else {
               
                selectionHeight = 45;
            }

            h = parseInt($("#header").height() + $(".div-visual").height() + $(".Cockpit1 .date").height() + selectionHeight +70);        
            h = browserHeight - h;
            if (h < 0) { h = 0 }


            me.visual.find("#div-details").height((h));
            visual.fadeIn();
            me.visual.find("#div-details").removeClass("hidden");

            //me.visual.find("#div-details").height(me.visual.find("#div-details").height() + (h - 30));
           
            me.vcVisual.addVisualBaseByName("div-det","VISUAL_COCKPIT_DETAILS", 'ails', me.day, parseInt(me.visual.find("#div-details").height(), 10), parseInt(me.visual.find("#div-details").width(), 10), "",
                JSON.stringify({ "signalid": me.bsaid, "UsePrices": me.usePrices, "ShowChildsInHrChart": me.showChildsInHrChart  }), me.deviceType);

        } else {
            //me.visual.find(".div-visual .chart").hide();
            me.visual.find(".div-visual .chart").html("");
            me.visual.find(".div-visual").fadeIn();
           me.visual.find("#div-details").addClass("hidden");
            _VCMQ.produce(me.visual, me.vcgid, 'CHANGE_DATE', { 'dates': me.dates, 'interval': me.interval, 'usePrices': me.usePrices, 'vcgid':-1 });

        } 

        return true;
    } catch (ex) { me.writeError('toggleDetails', ex); return false; }
};




Cockpit1.prototype.doEvent = function (event) {
    /// <summary>
    /// Handles different VCMQ messages
    /// </summary>
    var me = this;
  
    try {
        if (event !== null) {

            switch (event.msg) {
               
            case 'TOGGLE_DETAILS':
                me.toggleDetails(event.values);
                break;

                case 'GET_DATE':

                

                    _VCMQ.produce(me.visual, me.vcgid, 'CHANGE_DATE', { 'dates': me.dates, 'interval': me.interval, 'usePrices': me.usePrices, 'vcgid':event.vcgid });
                    break;

                case 'RAMP_CLICK':
                    me.setIntervalFromRamp(event.values);
                    break;

            default:
                break;
            }
        }
    } catch (ex) { writeError('doEvent', ex); }
};

Cockpit1.prototype.setIntervalFromRamp = function (msg) {
    /// <summary>
    /// This function generates proper dates and the correct interval from a clicked point in a ramp chart. . 
    /// </summary>
    var me = this;
    var d;
    var interval;
    var year;
    var sMon;
    var mon, mon1;
    try {
     
        d = msg.senderPoint.n.dt;


        //console.info("setIntervalFromRamp: " + d);
        //console.info(msg);

        if (d.length < 4) { return true }

        switch (msg.interval) {
            case 1:
                if (msg.userDateDef === false) { return true; }
                interval = 1;
                d = d.substring(4, d.length);
                d = d.substring(0, 10);

                break;
            case 3:
                interval = 1;
                d = d.substring(4, d.length);
                break;
            case 5:

                if (msg.vcvid !== '283') {
                    interval = 3;
                    year = d.substring(4, d.length);
                    sMon = d.substring(0, 3);
                    mon = moment().month(sMon).format("M") + '';
                 
                    mon1 = mon;
                    //if (mon === '12') {
                        switch (sMon) {
                        case 'Jän':
                            mon1 = 1;
                            break;
                        case 'Mär':
                            mon1 = 3;
                                break;
                        case 'Mrz':
                            mon1 = 3;
                            break;
                        case 'Mai':
                            mon1 = 5;
                            break;
                        case 'Okt':
                            mon1 = 10;
                            break;
                        case 'Dez':
                            mon1 = 12;
                            break;
                        default:
                            break;
                        }
                    //} else {
                    //    mon1 = mon;
                    //}
                    d = '1.' + mon1 + '.' + year;
                } else {
                    interval = 5;
                    d = '1.1.' + d;

                }


                break;
            default:
                return true;
        }

        me.interval = interval;
     
        me.visual.find('.date-menu .button-toggle').removeClass("button-toggle-active");
        me.visual.find('.date-menu .button-toggle[data-interval=' + me.interval + ']').addClass("button-toggle-active");

        me.visual.find(' .date').vcDate("destroy");

        me.initDates(d);
        return true;
    } catch (ex) { me.writeError('setIntervalFromRamp', ex); return false }
};

Cockpit1.prototype.specificInfoHandling = function (bError) {
    /// <summary>
    /// This function  hides/fades out content on error state. 
    /// </summary>
    var me = this;
    try {
        if (bError) {
            me.visual.find('#divChart, #divContentSub1').hide();
        }
        return true;
    } catch (ex) { me.writeError('specificInfoHandling', ex); return false }
};
